import { Component, OnInit } from '@angular/core';
import { FormsModule }   from '@angular/forms';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SeoSocialShareService, SeoSocialShareData } from 'ngx-seo';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css']
})
export class RegisterComponent implements OnInit {

	res:string;

	dataLoading: boolean

	agreement: boolean = false

	fieldTextType: boolean

	constructor( private http : HttpClient, private router: Router, private _notification: MatSnackBar ) { }

	ngOnInit(): void {

	}

	onRegisterSubmit(f){
		this.dataLoading = true

		let value = (f.value);

		this.http.post(environment.api+'/api/users/register', value)
			.subscribe((response: any)=>{
				this.dataLoading = false
				var res = response;
				if(res.status == true){
					// this.router.navigate(['/verify-account'], { queryParams: { token: res.accessToken } })	//for email verification enable after otp is implemented
					this.router.navigate(['/login'], { queryParams: { isRegistered: 'true' } });		
				}
				else{ 
					this.res = response.error;
				}
			}, error => {
				this.dataLoading = false
				if(error.error){
					this.openNotification(error.error.msg)
				}
			});
	}

	openNotification(msg){
		this._notification.open(msg, 'Cancel', {
			duration: 2000,
			horizontalPosition: 'right'
		})
	}

	toggleFieldTextType() {
		this.fieldTextType = !this.fieldTextType;
	}

}
